import { useEffect, useState } from "react";
import { CardSwapSearchResultDto } from "../dtos/CardSwapSearchResultDto";
import { LoadingButton } from "@mui/lab";
import { Dialog, Stack, DialogContent, DialogActions } from "@mui/material";
import { DialogTitleClosable } from "../../../components/DialogTitleClosable";
import { bhpButtonSx } from "../../../styles/bhpStyles";
import CreditCardIcon from '@mui/icons-material/CreditCard';
import CancelIcon from '@mui/icons-material/Cancel';
import { CardSwapStatusCode, cardSwapStatusCodes } from "../enums/CardSwapStatusCode";
import { useCardSwap } from "../hooks/useCardSwap";
import { NewCardToggle } from "../NewCardToggle";
import { OldCardToggle } from "../OldCardToggle";


type CardSwapToggleDialogProps = {

    cardSwapSearchResultDto : CardSwapSearchResultDto;
    dialogOpen: boolean;
    onClose: ( isUpdated : boolean ) => void;

};


export const CardSwapToggleDialog : React.FC< CardSwapToggleDialogProps > = ( props : CardSwapToggleDialogProps ) => {

    const { cardSwapSearchResultDto, dialogOpen, onClose } = props;

    const [ dialogHeader, setDialogHeader ] = useState< string >( cardSwapStatusCodes[ cardSwapSearchResultDto.refCardSwapStatusCode ] );
    const [ isUpdated, setIsUpdated ] = useState< boolean >( false );
    const [ isUpdating, setIsUpdating ] = useState< boolean >( false );
    const [ oldCardsHeader, setOldCardsHeader ] = useState< string >( '' );
    
    const { cardSwapSearchResult } = useCardSwap( cardSwapSearchResultDto );


    useEffect( ( ) => {

        let oldCardsHeader = 'Old Cards';

        if( cardSwapSearchResult.refCardSwapStatusCode === CardSwapStatusCode.DeactivatingOldCards ){ 
          
            oldCardsHeader = 'Cards To Be Deactivated'; 

        } else if( cardSwapSearchResult.refCardSwapStatusCode === CardSwapStatusCode.ReadyToCollect ){ 
            
            oldCardsHeader = 'Cards To Be Returned'; 

        }
        else if( cardSwapSearchResult.refCardSwapStatusCode === CardSwapStatusCode.ReturningOldCards ){ 
            
            oldCardsHeader = 'Cards To Be Returned'; 
        
        }

        setOldCardsHeader( oldCardsHeader );

        setDialogHeader( cardSwapStatusCodes[ cardSwapSearchResultDto.refCardSwapStatusCode ] );


    }, [ cardSwapSearchResult ] );


    const handleClose = ( ) => {

        if( !isUpdating ) {
            
            if( isUpdated ) {
                
                onClose( true );

            } else {
                
                onClose( false );
                
            }
            
        }

    };


    return(

        <Dialog
            onClose={ handleClose }
            open={ dialogOpen }
            sx={{ '& .MuiDialog-paper': { minHeight: 435, width: '500px' } }}
        >
            <DialogTitleClosable onClose={ handleClose }>
                <Stack direction="row" display="flex" alignItems="center" gap={ 0.5 }>
                    <CreditCardIcon /> 
                    { dialogHeader }
                </Stack>
            </DialogTitleClosable>

            <DialogContent dividers>
                
                <ul>

                    <li><b>First Name:</b> { cardSwapSearchResult.firstName }</li>
                    <li><b>Last Name:</b> { cardSwapSearchResult.surname }</li>
                    <li><b>Email:</b> { cardSwapSearchResult.email }</li>
                    <li><b>Employee / ERMS ID:</b> { cardSwapSearchResult.employeeNumber }</li>
                    <li><b>Card Collection Village:</b> { cardSwapSearchResult.villageCode }</li>

                </ul>

                <h2>New Card</h2>

                <NewCardToggle
                    cardSwapSearchResultDto = { cardSwapSearchResult }
                    isUpdating={ isUpdating }
                    setDialogHeader={ setDialogHeader }
                    setIsUpdated={ setIsUpdated }
                    setIsUpdating={ setIsUpdating }

                />

                { 
                    cardSwapSearchResult.oldCards.length > 0
                        &&
                    <h2>{ oldCardsHeader }</h2>
                }

                {
                    cardSwapSearchResult.oldCards.map( oldCard =>

                        <OldCardToggle 
                            cardSwapSearchResultDto={ cardSwapSearchResultDto }
                            isUpdating={ isUpdating }
                            key={ oldCard.cardNumber }
                            oldCardDto={ oldCard } 
                            setDialogHeader={ setDialogHeader }
                            setIsUpdated={ setIsUpdated }
                            setIsUpdating={ setIsUpdating }
                        /> 

                    )
                }

            </DialogContent>
            
            <DialogActions>

                <LoadingButton
                        disabled={ isUpdating }
                        loading={ isUpdating }
                        loadingPosition="start"
                        onClick={ handleClose } 
                        startIcon={ <CancelIcon /> }
                        sx={{ ...bhpButtonSx }} 
                        variant="contained"
                >
                    { isUpdated ? 'Close' : 'OK' }
                </LoadingButton>

            </DialogActions>

        </Dialog>


    );

};